/**
 * Defines the columns
 * And any action against the columns
 */
export class SoftwareCollectorPackagesColumnsModel {
	private _columns: Array<any>;
	constructor() {
		this._columns = [
			{
				headerName: 'Title',
				field: 'title',
				width: 120,
				resizable: false
			},
			{
				headerName: 'Active',
				field: 'active',
				width: 120
			},
			{
				headerName: 'Package Name',
				field: 'packageName',
				width: 120
			},
			{
				headerName: 'Assigned To',
				width: 120,
				field: 'assignedTo'
			},
			{
				headerName: 'Access Level',
				field: 'accessLevel',
				width: 120
			},
			{
				headerName: 'Actions',
				width: 100,
				cellRenderer: 'CustomActionSoftwareCollectorPackageCellComponent'
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}
